import { useDatastore, useSessionData } from "util/datastore";
import { PadBox } from "component/basics";
import { UtilityText } from "component/text";
import { Toggle } from "component/form";
import { Feature } from "util/stdtypes";
import type { Comment, CommentConfig } from "component/comment";
import type { Datastore } from "util/datastore";

export type CatComment = Comment & { isCat?: boolean };

export const DemoFilterFeature: Feature<CommentConfig, {}> = {
    name: 'Demo Filter',
    key: 'demofilter',
    config: {
        pageTopWidgets: [TypeFilter],
        commentFilters: [filterFunc],
        commentEditTopWidgets: [CatToggle],
        commentTopWidgets: [CatState],
        commentAllowEmpty: true,
        composerSubtitle: ({comment}) => comment?.text ? '!Demo Comment' : '!Empty Comment',
    }
} 

export function TypeFilter({comments}: {comments: CatComment[]}): JSX.Element {
    const datastore = useDatastore();
    const enabled = useSessionData(['demofilter', 'enabled']);
    function setEnabled(value: boolean) {
        datastore.setSessionData(['demofilter', 'enabled'], value);
    }
    return <PadBox top={20} horiz={20}><Toggle label='!Only Cats' value={enabled} onChange={setEnabled} /></PadBox>
}

export function filterFunc({datastore, comment}: {datastore: Datastore; comment: CatComment}): boolean {
    const enabled = datastore.getSessionData(['demofilter', 'enabled']); 
    if (enabled) {
        return !!comment.isCat;
    } else {
        return true;
    }
}

export function CatToggle({comment, setComment}: {comment: CatComment; setComment: (c: CatComment) => void}): JSX.Element {
    return (
        <PadBox bottom={10} left={16}>
            <Toggle label='!Is Cat' value={comment.isCat ?? false}
                onChange={isCat => setComment({ ...comment, isCat })} />
        </PadBox>
    );
}

export function CatState({comment}: {comment: CatComment}): JSX.Element | null {
    if (comment.isCat) {
        return <PadBox bottom={10}><UtilityText weight='medium' label='!Is a cat' /></PadBox>;
    }
    return null;
}
